import { render, staticRenderFns } from "./seriesLessonsInfo.vue?vue&type=template&id=3a94c71a&scoped=true"
import script from "./seriesLessonsInfo.vue?vue&type=script&lang=js"
export * from "./seriesLessonsInfo.vue?vue&type=script&lang=js"
import style0 from "./seriesLessonsInfo.vue?vue&type=style&index=0&id=3a94c71a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a94c71a",
  null
  
)

export default component.exports